<div class="stats-card">
  <app-row gutter="sm" class="stats-card__list">
    <app-col *ngFor="let status of statues">
      <app-stats-card [theme]="status.theme" [inverted]="status.inverted">
        <app-icon class="align-middle" [name]="status.icon"></app-icon>
        <span title riyalCurrency class="flex align-center text-nowrap">   
        {{status.amount | number:'1.0-2'}}</span>
        <span subtitle>{{ "invoices.InvoiceList.FleetInvoiceStatus." + status.status | translate }}</span>
        <span ribbon>{{status.count | number:'1.0-2'}}</span>
      </app-stats-card>
    </app-col>
  </app-row>
</div>
